import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursAbout() {
  return <section className="py-20 lg:py-32 bg-brand-cream relative overflow-hidden" data-id="element-655">
      <div className="max-w-7xl mx-auto px-6" data-id="element-656">
        {/* Mobile-only centered title (shown above the photo on mobile) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="lg:hidden mb-10 text-center" data-id="element-657">
          <SectionHeading title="Cine sunt eu și de ce am creat cursul Magnet pentru Bani" centered={true} data-id="element-658" />
        </motion.div>

        <div className="grid lg:grid-cols-[2fr_3fr] gap-12 lg:gap-20 items-stretch" data-id="element-659">
          {/* Image — fills the full height of the text column edge-to-edge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative w-full max-w-[400px] mx-auto lg:mx-0 lg:max-w-none aspect-[3/4] lg:aspect-auto lg:min-h-full" data-id="element-660">
            {/* Subtle decorative elements outside the photo */}
            <div className="hidden lg:block absolute -top-6 -left-6 w-24 h-24 border-[1.5px] border-brand-gold/30 rounded-full pointer-events-none" data-id="element-661" />
            <div className="hidden lg:block absolute -bottom-6 -right-6 w-32 h-32 border border-brand-gold/25 rounded-full pointer-events-none" data-id="element-662" />
            <div className="hidden lg:block absolute -top-3 -right-3 w-2.5 h-2.5 bg-brand-gold/70 rotate-45 pointer-events-none" data-id="element-663" />

            {/* Image fills the entire container */}
            <div className="absolute inset-0 rounded-[32px] overflow-hidden shadow-warm" data-id="element-664">
              <img src="https://cdn.magicpatterns.com/uploads/hbWtuJ6aCvHUuJajw2QL9A/Screenshot_2026-05-15_at_21.29.02.png" alt="Adrian Huniade" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-665" />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-666">
            {/* Desktop-only heading inside text column */}
            <div className="hidden lg:block" data-id="element-667">
              <SectionHeading title="Cine sunt eu și de ce am creat cursul Magnet pentru Bani" centered={false} data-id="element-668" />
            </div>

            <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed mb-10" data-id="element-669">
              <p data-id="element-670">
                Sunt <strong data-id="element-671">Adrian Huniade</strong>, Instructor Internațional
                Theta Healing® și Facilitator Heal Your Life, cu peste 25 de
                ani de experiență în terapii complementare și dezvoltare
                personală.
              </p>
              <p data-id="element-672">
                Am creat cursul Magnet pentru Bani pentru că am văzut un tipar
                care se repeta la aproape fiecare persoană cu care lucram:
                oameni inteligenți, muncitori, dedicați, care nu înțelegeau de
                ce banii nu vin sau nu rămân. Și de fiecare dată, răspunsul era
                același: credințe limitative din subconștient, moștenite din
                familie sau formate în copilărie, care lucrau împotriva lor fără
                să știe.
              </p>
              <p data-id="element-673">
                Am folosit tehnici și exerciții practice testate pe sute de
                cursanți ca să creez un curs care nu doar te învață despre bani,
                ci îți schimbă relația cu ei la nivel profund.
              </p>

              <p className="text-xl md:text-2xl font-subtitle text-brand-purple font-medium py-4" data-id="element-674">
                Un exemplu concret: tehnica "propoziția win-win" din acest curs
                m-a ajutat personal să semnez contracte care mi-au adus venituri
                de peste 100.000 de euro în 3 ani.
              </p>

              <div className="p-6 bg-brand-purple/5 border-l-4 border-brand-purple rounded-r-xl" data-id="element-675">
                <p className="font-subtitle italic text-xl text-brand-text" data-id="element-676">
                  "Nu e magie. E o schimbare reală de mentalitate pusă în
                  practică."
                </p>
              </div>
            </div>

            <CTAButton className="items-start" data-id="element-677" />
          </motion.div>
        </div>
      </div>
    </section>;
}